<template>
  <div class="navegacion-wrapper ayuda-scope">
    <v-btn-toggle v-model="activeTab" mandatory borderless class="botonera-custom">
      <v-btn value="web" class="btn-plataforma">
        <div class="btn-content">
          <feather type="monitor" class="feather-icon"></feather>
          <span class="btn-text">Web</span>
        </div>
      </v-btn>

      <v-btn value="moviles" class="btn-plataforma">
        <div class="btn-content">
          <feather type="smartphone" class="feather-icon"></feather>
          <span class="btn-text">Moviles</span>
        </div>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  name: 'PlataformaNavegacion',
  data() {
    return {
      activeTab: 'web'
    }
  },
  watch: {
    activeTab(val) {
      this.$emit('cambio-plataforma', val);
    }
  }
}
</script>

<style scoped>
.navegacion-wrapper{
  margin-bottom: 16px;
}

.btn-text{
  margin-left: 5px;
}
.botonera-custom {
  display: flex !important;
  width: 100% !important;
  /* Quitamos fondo y bordes del contenedor */
  background-color: transparent !important;
  border: none !important;
  border-bottom: 1px solid var(--border-color) !important; /* Línea base gris */
  border-radius: 0 !important;
  padding: 0 !important;
  height: auto !important;
  justify-content: flex-start !important;
}

.btn-plataforma {
  /* CAMBIO CLAVE: flex: none para que no se estiren */
  flex: none !important; 
  width: auto !important; /* Que el ancho lo de el contenido */
  min-width: 120px !important; /* Un ancho mínimo para que respiren */
  height: 50px !important;
  background-color: transparent !important;
  color: var(--text-color) !important;
  border: none !important;
  box-shadow: none !important;
  text-transform: none !important;
  margin-right: 20px; /* Espacio real entre pestañas */
  transition: all 0.3s ease;
  position: relative;
  opacity: 0.7;
}

/* Pseudo-elemento para la línea inferior animada */
.btn-plataforma::after {
  content: '';
  position: absolute;
  bottom: 0px; /* Ajustado al borde inferior */
  left: 0;
  width: 100%;
  height: 2px; /* Un poco más fina se ve más elegante */
  background-color: var(--primary-color);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.btn-plataforma:hover {
  opacity: 1;
}

/* --- ESTADO ACTIVO --- */

.v-btn--active {
  background-color: transparent !important; /* Sin fondo */
  color: var(--primary-color) !important;    /* Texto del color de tu marca */
  opacity: 1 !important;
}

/* Mostramos la línea cuando está activo */
.v-btn--active::after {
  transform: scaleX(1);
}

.v-btn--active .feather-icon {
  stroke: var(--primary-color); /* Icono también cambia de color */
}

/* Quitamos efectos de hover de Vuetify para que se vea limpio */
.v-btn:before {
  display: none !important;
}

/* Ajustes Responsivos para mantener la línea */
@media (max-width: 600px) {
  .btn-plataforma {
    height: 60px !important;
  }
}
</style>